import React from 'react'
import ReactDOM from 'react-dom'
import { HashRouter as Router, Switch, Route, Redirect, Link } from 'react-router-dom'
import './base.css'
import Demo1 from './demos/Demo1'
import Demo2 from './demos/Demo2'
import myLogo from './svg/jph-logo.svg'

// Inspired by:
// https://twitter.com/beesandbombs/status/1329796242298245124

function App() {
  return (
    <Router basename="/">
      <div className="frame">
        <div className="frame__demos">
          <a href="https://www.linkedin.com/in/johnpaulhennessy/" className="frame__demo" target="_blank" rel="noopener noreferrer">
            LinkedIn
          </a>
          <a href="https://www.instagram.com/yewnork/" className="frame__demo" target="_blank" rel="noopener noreferrer">
            Instagram
          </a>
          <a href="https://x.com/jphennessy5" className="frame__demo" target="_blank" rel="noopener noreferrer">
            Twitter
          </a>
        </div>
      </div>
      <div className="content">
        <div className="logo"><img  src={myLogo} alt="SVG logo image"/></div>
        <h2 className="content__title">John Paul Hennessy</h2>
        <p>Product, User Experience and Brand Design</p>
      </div>
      <div id="animation">
        <Switch>
          <Route exact path="/demo1">
            <Demo1 />
          </Route>
          <Route exact path="/demo2">
            <Demo2 />
          </Route>
          <Route path="*">
            <Redirect to="/demo1" />
          </Route>
        </Switch>
      </div>
    </Router>
  )
}

ReactDOM.render(<App />, document.getElementById('root'))
